import { render, staticRenderFns } from "./EditAntecedent.vue?vue&type=template&id=59b0659a&scoped=true"
import script from "./EditAntecedent.vue?vue&type=script&lang=js"
export * from "./EditAntecedent.vue?vue&type=script&lang=js"
import style0 from "./EditAntecedent.vue?vue&type=style&index=0&id=59b0659a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b0659a",
  null
  
)

export default component.exports